import styled from '@emotion/styled';
import { Section } from '@/components/pages/about/comm/Layout';
import PartnerLogoAnimation from '@/components/pages/about/comm/PartnerLogoAnimation';
import { breakpointMedium } from '@/constants/breakpoints';

const PartnerSection = () => {
  return (
    <Section.Container>
      <StyledSectionInner>
        <StyledSectionHgroup>
          <Section.Title>
            이미 많은 기업들이 프로그래머스 자격증을 활용하고 있어요.
          </Section.Title>
          <Section.Subtitle>
            코딩테스트 면제, 채용 우대 등 다양한 방면으로 활용하는 자격증으로
            커리어 Step - Up!
          </Section.Subtitle>
        </StyledSectionHgroup>

        <List>
          <PartnerLogoAnimation group="first" direction="left" />
          <PartnerLogoAnimation group="second" direction="right" />
        </List>
      </StyledSectionInner>
    </Section.Container>
  );
};

export default PartnerSection;

const StyledSectionInner = styled(Section.Inner)`
  display: flex;
  max-width: none;
  flex-direction: column;
  align-items: center;
  padding: 80px 0px;
  gap: 48px;

  @media (max-width: ${breakpointMedium}) {
    padding: 60px 0px;
    gap: 40px;
  }
`;

const StyledSectionHgroup = styled(Section.Hgroup)`
  width: 100%;
  max-width: 1200px;
  padding: 0 16px;

  @media (max-width: ${breakpointMedium}) {
    padding: 0 20px;
  }
`;

const List = styled.ul`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0;
  gap: 24px;
  list-style: none;
`;
